import { IconChartLine } from '@rossum/ui/icons/tabler';
import { Stack } from '@rossum/ui/material';
import InfoPlaceholder from '../../../components/UI/InfoPlaceHolder';

const exportedDependentGraphs = [
  'delay',
  'correctionsPerDocumentAvg',
  'turnaroundAvgS',
  'timePerDocumentAvgS',
];

type Props =
  | {
      inGraph: true;
      graphName: string;
    }
  | {
      inGraph: false;
    };

const EmptySeries = (props: Props) => (
  <Stack width="100%" height="100%" justifyContent="center" alignItems="center">
    <InfoPlaceholder
      icon={IconChartLine}
      inGraph={props.inGraph}
      title="containers.statistics.noData"
      text={
        props.inGraph && exportedDependentGraphs.includes(props.graphName)
          ? 'containers.statistics.noDataInGraph.text'
          : 'containers.statistics.noData.text'
      }
    />
  </Stack>
);

export default EmptySeries;
